module.exports = __webpack_public_path__ + "img/009-purpose.8753225a.svg";